export const RoutesNames = {
  home: "/",
  OptionsLegalAndDocumental: "/legalAndDocumental/",
  rumv: "/legalAndDocumental/RUMV",
  biometric: "/legalAndDocumental/BiometricRegistration",
  documents: "/legalAndDocumental/DocumentsDelivery",
  optionsHealth: "/health/",
  affiliateHealthForm: "/health/AffiliateFormHealth",
  login: "/login",
  main: "/main",
  othersForms: "/legalAndDocumental/OthersForms",
  othersFormsStandard: "/legalAndDocumental/OthersFormsStandard",
  detailOthers: "/legalAndDocumental/DetailOthers",
  healthForm: "/health/registersHealth",
  healthFormStandard: "/health/registersHealthStandard",
  DetailHealth: "/health/detailHealthRegister",
  interestThemes: "/interestThemes",
  serviceGuide: "/serviceGuide/",
  Directory: "/serviceGuide/Directory",
};
